import { render, staticRenderFns } from "./shareData.vue?vue&type=template&id=46e473e2&scoped=true&"
import script from "./shareData.vue?vue&type=script&lang=js&"
export * from "./shareData.vue?vue&type=script&lang=js&"
import style0 from "./shareData.vue?vue&type=style&index=0&id=46e473e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e473e2",
  null
  
)

export default component.exports